import React from 'react';
import { App } from '../features/home';
// import { PageNotFound } from '../features/common';
import homeRoute from '../features/home/route';
import commonRoute from '../features/common/route';
import sessionRoute from '../features/session/route';
import notesRoute from '../features/notes/route';
import chatRoute from '../features/chat/route';
import thoughtJournalRoute from '../features/thought-journal/route';
import foodJournalRoute from '../features/food-journal/route';
import sleepJournalRoute from '../features/sleep-journal/route';
import modulesRoute from '../features/modules/route';
import dashboardRoute from '../features/dashboard/route';
import profileRoute from '../features/profile/route';
import feedsRoute from '../features/feeds/route';
import groupsRoute from '../features/groups/route';
import progressRoute from '../features/progress/route';
import engagementRoute from '../features/engagement/route';
import plannerRoute from '../features/planner/route';
import overviewRoute from '../features/overview/route';
import changePasswordRoute from '../features/change-password/route';
import broadcastRoute from '../features/broadcast/route';
import cognitoRoute from '../features/cognito/route';
import newProfileRoute from '../features/new-profile/route';
import prudentialRoute from '../features/prudential/route';
import videoCallRoute from '../features/video/route';
import whatsappGroupsRoute from '../features/whatsapp-groups/route';
import RemoteTherapyRoute from '../features/remote-therapy/route';
import MemberAppointmentRoute from '../features/remote-therapy/memberRoute';
import moodJournalRoute from '../features/mood-journal/route';

const PageNotFound = React.lazy(() => import('../features/common/PageNotFound'));

// NOTE: DO NOT CHANGE the 'childRoutes' name and the declaration pattern.
// This is used for Rekit cmds to register routes config for new features, and remove config when remove features, etc.
const childRoutes = [
  homeRoute,
  commonRoute,
  sessionRoute,
  notesRoute,
  chatRoute,
  thoughtJournalRoute,
  foodJournalRoute,
  sleepJournalRoute,
  modulesRoute,
  dashboardRoute,
  profileRoute,
  feedsRoute,
  groupsRoute,
  progressRoute,
  engagementRoute,
  plannerRoute,
  overviewRoute,
  changePasswordRoute,
  broadcastRoute,
  cognitoRoute,
  newProfileRoute,
  prudentialRoute,
  videoCallRoute,
  whatsappGroupsRoute,
  RemoteTherapyRoute,
  MemberAppointmentRoute,
  moodJournalRoute,
];

const routes = [
  {
    path: '/',
    component: App,
    childRoutes: [
      ...childRoutes,
      { path: '*', name: 'Page not found', component: PageNotFound },
    ].filter(r => r.component || (r.childRoutes && r.childRoutes.length > 0)),
  },
];

// Handle isIndex property of route config:
//  Dupicate it and put it as the first route rule.
function handleIndexRoute(route) {
  if (!route.childRoutes || !route.childRoutes.length) {
    return;
  }

  const indexRoute = route.childRoutes.find(child => child.isIndex);
  if (indexRoute) {
    const first = { ...indexRoute };
    first.path = '';
    first.exact = true;
    first.autoIndexRoute = true; // mark it so that the simple nav won't show it.
    route.childRoutes.unshift(first);
  }
  route.childRoutes.forEach(handleIndexRoute);
}

routes.forEach(handleIndexRoute);
export default routes;



// WEBPACK FOOTER //
// ./src/common/routeConfig.js